export enum ObjectType {
    Advertiser = 'advertiser',
    Campaign = 'campaign',
    Creative = 'creative',
    Deal = 'deal',
    Company = 'company'
}